import React from "react";

import dompurify from "dompurify";
import * as yup from "yup";

import { Typography } from "clearsense-ui/components";

import { snakeCaseToString } from "./utils";

const sanitizer = dompurify.sanitize;

const truncate = value =>
  value.substring(
    value.indexOf("</strong>") - 150 > 0 ? value.indexOf("</strong>") - 100 : 0,
    value.indexOf("</strong>")
  );

export const FIELDS_VALLEY_CHILDREN = [
  {
    header: "Program",
    nestedHeaders: ["Title", "Referred Date", "Admitted Date"],
  },
  {
    header: "IDTS",
    nestedHeaders: ["Date", "By"],
  },
  {
    header: "Intervention",
    nestedHeaders: ["Intervention", "Result Outcome", "Factors"],
  },
  {
    header: "Goal",
    nestedHeaders: ["Goal", "Set for", "Results"],
  },
];

export const FIELDS_NATIONAL_RAD = [
  "Patient name",
  "Date of birth",
  "Report number",
  "Physician",
  "Exam",
  "Report date",
  "Clinical information",
  "Comparison",
  "Contrast",
  "Technique",
  "Findings",
  "Level by level analysis",
  "Other findings",
  "Impression",
];

export const INITIAL_FORM_VALUES = {
  term: "",
  "Patient name": false,
  "Date of birth": false,
  "Report number": false,
  Physician: false,
  Exam: false,
  "Report date": false,
  "Clinical information": false,
  Comparison: false,
  Contrast: false,
  Technique: false,
  Findings: false,
  "Level by level analysis": false,
  "Other findings": false,
  Impression: false,
};

export const FORM_VALIDATION = yup.object().shape({
  term: yup.string().trim().required("Search term cannot be blank."),
});

export const COLUMN_DATA = isValleyChildren => [
  {
    dataIndex: "metadata",
    key: isValleyChildren ? "id" : "report_number",
    title: isValleyChildren ? "Report Id" : "Report number",
    sorter: true,
    width: isValleyChildren ? 100 : "15%",
    render: (_, record) => {
      const value = isValleyChildren
        ? record?.metadata?.id
        : record?.metadata?.report_number;
      return (
        <Typography
          style="large"
          className="text-content-dark"
          data-cy="result-report-number"
        >
          {value}
        </Typography>
      );
    },
    fixed: "left",
  },
  {
    dataIndex: "metadata",
    key: isValleyChildren ? "name" : "patient_name",
    title: "Patient Name",
    sorter: true,
    width: isValleyChildren ? 150 : "15%",
    render: props => {
      const value = isValleyChildren ? props.name : props.patient_name;
      return (
        <Typography
          style="large"
          className="text-content-dark"
          data-cy="result-patient-name"
        >
          {value}
        </Typography>
      );
    },
  },
  {
    dataIndex: "file_name",
    key: "file_name",
    title: "File name",
    width: 225,
    sorter: (a, b) => a.file_name - b.file_name,
    render: (file_name, records) => (
      <div className="flex flex-col space-y-2" data-cy="result-file-name">
        <Typography style="large" className="text-content-dark">
          {file_name}
        </Typography>
        <Typography
          style="large"
          className="flex flex-col space-y-2 text-content-dark"
        >
          {Object.keys(records.highlights)?.map(highlight => (
            <div key={highlight}>
              <Typography type="semibold">
                {snakeCaseToString(highlight)}:
              </Typography>
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizer(truncate(records.highlights[highlight])),
                }}
              ></p>
            </div>
          ))}
        </Typography>
      </div>
    ),
  },
  {
    dataIndex: "metadata",
    key: isValleyChildren ? "dob" : "report_date",
    title: isValleyChildren ? "Date of birth" : "Date",
    sorter: true,
    width: isValleyChildren ? 100 : "20%",
    render: (_, record) => {
      const value = isValleyChildren
        ? record?.metadata?.dob
        : record?.metadata?.report_date;
      return (
        <Typography
          style="large"
          className="text-content-dark"
          data-cy="result-data"
        >
          {value}
        </Typography>
      );
    },
  },
];
